module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/stag-and-hen-parties.json
// module id = 737
// module chunks = 86042383948303